import { render, staticRenderFns } from "./StatisticAuthWidget.vue?vue&type=template&id=63e86fd8"
import script from "./StatisticAuthWidget.vue?vue&type=script&lang=js"
export * from "./StatisticAuthWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports